import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { BankDetailsService } from '../../../core/services/bank/bank-details/bank-details.service'
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'bank-details-create',
  imports: [ReactiveFormsModule, MatButton, MatProgressSpinner, MatInputModule],
  templateUrl: './bank-details-create.component.html',
  styleUrl: './bank-details-create.component.scss',
  providers: [BankDetailsService],
  standalone: true,
})
export class BankDetailsCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private bankDetailsService: BankDetailsService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.bankDetailsService.createBankDetails(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      pessoaId: 0,
      bancoId: this.form.controls['bank'].value,
      agencia: this.form.controls['bank_branch'].value,
      conta: this.form.controls['bank_account'].value,
      pix: this.form.controls['pix'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      bank: ['', [Validators.required]],
      bank_branch: ['', [Validators.required]],
      bank_account: ['', [Validators.required]],
      pix: [''],
    })
  }
}
